





























import { Component, Prop } from 'vue-property-decorator';
import { AbstractProductWidget } from '@/views/product/widgets/AbstractProductWidget';
import ProductImage from '@/views/product/common/ProductImage.vue';
import ProductTitle from '@/views/product/common/ProductTitle.vue';
import Routes from '@/util/Routes';
import { Urls } from '@/util/Urls';
import { ShoppingCartItemDto } from '@/api';

@Component({
  components: {
    ProductImage,
    ProductTitle,
  },
})
export default class OrderProduct extends AbstractProductWidget {

  @Prop({required: false})
  public item: ShoppingCartItemDto | undefined;

  public async mounted() {
    if (this.isReadOnly) {
      this.localItem = this.item!;
    }
  }

  private goToDetailPage() {
    if (this.isActive) {
      this.$emit('productSelect', this.product);
      this.$router.push({
        name: Routes.ProductDetail,
        params: {
          sku: this.product.product.sku,
          unitAbbreviation: this.product.unit.abbreviation,
          urlName: Urls.toLinkFriendlyString(this.product.product.name),
        },
      });
    }
  }
}
